import { render, staticRenderFns } from "./Centre_productie_list.vue?vue&type=template&id=1a84ce93&scoped=true"
import script from "./Centre_productie_list.vue?vue&type=script&lang=js"
export * from "./Centre_productie_list.vue?vue&type=script&lang=js"
import style0 from "./Centre_productie_list.vue?vue&type=style&index=0&id=1a84ce93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a84ce93",
  null
  
)

export default component.exports